export default "__VITE_ASSET__4cc1a84d__"